module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Prop-types","commonjs2":"prop-types","commonjs":"prop-types","amd":"prop-types"}
// module id = 5
// module chunks = 0